<template>
        <Dialog :visible.sync="isExibirTela" :contentStyle="dimensaoTela()" 
            :header="tituloTela" :modal="modal" class="cadastro-rapido-seplag" :closable="visivelFechar" >
                <div class="p-cardialog-content">
                    
                    <form-seplag ref="formulario" >
                        <slot></slot>
                    </form-seplag>

                </div>
            
                <template #footer>
                    <Button :label="textoButton? textoButton : 'Enviar link de ativação'" icon="pi pi-check" v-if="modoEdicao==='enviaremailativacao'"
                        @click="enviaremailativacao" class="p-button-success" />
                    <Button :label="textoButton? textoButton : 'Adicionar'" icon="pi pi-check" v-if="modoEdicao==='adicionar'"
                        @click="adicionar" class="p-button-success" />
                    <Button :label="textoButton? textoButton : 'Alterar'" icon="pi pi-check" v-if="modoEdicao==='alterar'"
                        @click="alterar" class="p-button-primary" />
                    <Button :label="textoButton? textoButton : 'ok'" icon="pi pi-check" @click="fecharTela" class="p-button-success" v-if="confirmarSimples" />
                    <Button label="Cancelar" icon="pi pi-ban" @click="fecharTela" class="p-button-danger" v-if="visivelFechar" />
                </template>
        </Dialog>
</template>

<script>
import FormSeplag from '@/template/FormSeplag.vue'

export default {
    name: 'CadRapidoSeplag',
    components: { FormSeplag },
    model: {
        prop: 'exibirTela',
        event: 'change'
    },
    props: {
        exibirTela: {
            // Propriedade utilizada para exibir a tela do diálogo do cadastro rápido
            type: Boolean,
            required: true
        },  
        tituloTela: {
            // Título a ser exibido na tela de cadastro rápido
            type: String,
            required: true
        },
        modal: {
            // Informa se tela do cadastro rápido deve ser exibido no modo modal, default=true
            type: Boolean, 
            default: true           
        },
        visivelFechar: {
            // Informa se tela do cadastro rápido deve ser exibido no modo modal, default=true
            type: Boolean,
            default: true
        },
        confirmarSimples: {
            // Informa se tela do cadastro rápido deve ser exibido no modo modal, default=true
            type: Boolean,
            default: false
        },
        textoButton: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        tamanhoTela: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        alturaTela: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        modoEdicao: {
            validator: function(value) {
                // O valor da propriedade deve possuir um destes valores
                return ['adicionar', 'alterar','enviaremailativacao'].indexOf(value) !== -1
            }
        },
        onAdicionar: {
            // Evento disparado para informar a adição do registro
            type: Function
        },
        onAlterar: {
            // Evento disparado para informar a alteração do registro
            type: Function
        },

        onEnviarLinkAtivacao: {
            // Evento disparado para enviar link de ativação
            type: Function
        }
    },
    methods: {
        dimensaoTela(){    
            let tela = ""            
            if(this.tamanhoTela && this.tamanhoTela.indexOf('.')> 0){
                let css = this.tamanhoTela.split('.')                
                 tela = tela + `width: ${css[0]}${css[1]};`
            }else if(this.tamanhoTela){
                tela = tela + `width: ${this.tamanhoTela}px;`                     
            }else{
                tela = tela + 'width: 400px'   
            }            
            if(this.alturaTela){
               tela = tela + `height: ${this.alturaTela}px;`                 
            }
            return tela
        },        
        alterar(){
            if (!this.$refs.formulario.validar()){
                this.$toast.add({severity:'error', summary: 'Um ou mais campos obrigatórios (em destaque) não foram preenchidos!', 
                life: 3000})
                return 
            }
            // Fecha a janela
            this.fecharTela()
            // Dispara o evento de alterar registro
            this.onAlterar()
        },
        adicionar(){
            if (!this.$refs.formulario.validar()){
                this.$toast.add({severity:'error', summary: 'Um ou mais campos obrigatórios (em destaque) não foram preenchidos!', 
                life: 3000})
                return 
            }
            // Fecha a janela
            this.fecharTela()
            // Dispara o evento de adicionar registro
            this.onAdicionar()
        },
        enviaremailativacao(){
            this.onEnviarLinkAtivacao()
        },
        fecharTela(){
            this.isExibirTela = !this.isExibirTela
        }
    },
    computed: {
        isExibirTela: {
            get(){
                return this.exibirTela
            },
            set(){
                // Emite uo evento personalizado para que seja modificado na origem
                this.$emit('change', !this.exibirTela)
            }
        }
    }
}
</script>

<style scoped>

@media screen and (max-width: 40em) {
   .cadastro-rapido-seplag {
        width: 100% !important;
    }
    .p-dialog-content{
        width: 100% !important;
        word-wrap: break-word;
    } 
}

</style>